<template>
  <div id="get-quotation" uk-height-viewport>
    <Header />
    <div class="uk-card uk-padding uk-flex uk-flex-center uk-animation-fade" uk-height-viewport>
      <div class="uk-container uk-container">
        <div class="uk-grid-margin uk-grid uk-grid-stack" uk-grid>
          <div class="uk-width-1-1@m">
            <div
              class="uk-margin uk-width-large uk-card uk-card-default uk-card-body uk-box-shadow-large uk-border-rounded"
            >
              <h3 class="uk-card-title uk-text-left">Entrez votre identifiant de devis</h3>
              <p class="uk-card-small uk-text-left">Identifiant à 8 caractères alpha-numérique</p>
              <form v-on:submit.prevent="getQuotationByID()">
                <div class="uk-margin">
                  <div class="uk-inline uk-width-1-1">
                    <input
                      minlength="8"
                      maxlength="8"
                      placeholder="ABCD1234"
                      class="uk-input uk-form-large uk-border-rounded"
                      type="text"
                      v-model="quotationID"
                    />
                  </div>
                </div>
                <div class="uk-margin">
                  <button
                    class="uk-button uk-button-primary uk-button-large uk-width-1-1 uk-border-rounded uk-text-bold"
                  >Récupérer</button>
                  <div
                    class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
                    uk-spinner
                    v-show="isLoading"
                  ></div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import firebase from "firebase";
import UIkit from "uikit";
import Header from "@/components/Header.vue";
import router from "../router";

export default {
  name: "GetQuotation",
  components: { Header },
  data() {
    return {
      quotationID: "",
      isLoading: false,
      quotation: {}
    };
  },

  mounted() {},

  methods: {
    getQuotationByID: function() {
      firebase
        .firestore()
        .collection("Quotations")
        .where("quotationID", "==", this.quotationID)
        .get()
        .then(querySnapshot => {
          if (querySnapshot.docs.length != 1) {
            this.displayErrorMessage(
              "Aucun devis ne porte ce numéro d'identification."
            );
            return 
          }
          querySnapshot.forEach(() => {
            router.push({ path: `/check-quotation/${this.quotationID}`})
          });
        })
        .catch(error => {
          console.log(error)
          this.displayErrorMessage(
            "Aucun devis ne porte ce numéro d'identification."
          );
        });
    },

    isEmail: function() {},

    isSamePassword: function() {},

    displayErrorMessage: function(errorMessage) {
      UIkit.notification(
        "<span uk-icon='icon: warning'></span> " + errorMessage,
        { pos: "bottom-center", status: "danger" }
      );
    }
  }
};
</script>

<style scoped>
body {
  background-color: #ffffff;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='100%25' height='100%25' viewBox='0 0 800 400'%3E%3Cdefs%3E%3CradialGradient id='a' cx='396' cy='281' r='514' gradientUnits='userSpaceOnUse'%3E%3Cstop offset='0' stop-color='%23ffffff'/%3E%3Cstop offset='1' stop-color='%23ffffff'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='400' y1='148' x2='400' y2='333'%3E%3Cstop offset='0' stop-color='%232a93ac' stop-opacity='0'/%3E%3Cstop offset='1' stop-color='%232a93ac' stop-opacity='0.5'/%3E%3C/linearGradient%3E%3C/defs%3E%3Crect fill='url(%23a)' width='800' height='400'/%3E%3Cg fill-opacity='0.4'%3E%3Ccircle fill='url(%23b)' cx='267.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='532.5' cy='61' r='300'/%3E%3Ccircle fill='url(%23b)' cx='400' cy='30' r='300'/%3E%3C/g%3E%3C/svg%3E");
  background-attachment: fixed;
  background-size: cover;
}

a:hover {
  text-decoration: none;
  color: #2c3e50;
}
</style>